export const openAlertAction = alert => ({ type: 'OPEN_ALERT', alert });
export const openAlertSuccessAction = alert => ({ type: 'OPEN_ALERT_SUCCESS', alert });
export const openAlertErrorAction = alert => ({ type: 'OPEN_ALERT_ERROR', alert });
export const closeAlertAction = alert => ({ type: 'CLOSE_ALERT', alert });
export const closeAlertByKeyAction = key => ({ type: 'CLOSE_ALERT_BY_KEY', key });
